<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
      <a routerLink="/panel" class="danger">Listeye dön</a>
    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card  (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
            <b>   Etiket Onay Sayfası  </b>
             <span class="pull-right">

               <button class="btn btn-primary"
                 (click)="allonayla()">
                      <i class="la la-check" title="Onayla"  
                      style="font-size:30;cursor: pointer;font-weight: bold;color:white;"></i>
                      Tüm Eşdeğerleri Onayla</button>

               <button class="btn btn-danger" style="margin-left:20px;"
                 (click)="allkaldir()">
                      <i class="la la-check" title="Onayla"  
                      style="font-size:30;cursor: pointer;font-weight: bold;color:white;"></i>
                      Tüm Eşdeğerlerden onayı kaldır</button>

              <button class="btn btn-success" *ngIf="!label.accepted; else onayli" style="margin-left:20px;" (click)="onayla()"><i class="la la-check" title="Onayla"  style="font-size:30;cursor: pointer;font-weight: bold;color:white;"></i> Onayla</button>
            
              <ng-template #onayli>
                 <button class="btn btn-danger"  style="margin-left:20px;" (click)="kaldir()"><i class="la la-check" title="Kaldır"  style="font-size:30;cursor: pointer;font-weight: bold;color:white;"></i> Onayı kaldır</button>
              </ng-template>
           
              <button class="btn btn-primary" style="margin-left:20px;" (click)="openEditModal()">
              <i class="la la-edit"></i>
              Prompt ile düzenle</button>
            </span>
              </ng-container>
              <ng-container mCardBody>
                  
                <div class="row">
                  <div class="col-md-6">
                    <div *ngIf="label.reference" style="margin-bottom: 20px;color:red;font-weight: bold;">Bu etiket {{label.referenceName}} eşdeğerden üretilmiştir.</div>
                    <h3><b>Kullanım Talimatı</b></h3>
                    <div [innerHTML]="label?.belge"></div>
                  </div> 
                  
                  <div class="col-md-6">
                     <div class="row">
        <div class="col-md-12"> <button class="btn btn-primary pull-right ml-1"
                 (click)="mobiletiketonay()">
                      <i class="la la-edit" title="Düzenle"  
                      style="font-size:30;cursor: pointer;font-weight: bold;color:white;"></i>
                    Mobil  Etiketi düzenle</button>
          <button class="btn btn-primary pull-right mb-1"
                 (click)="etiketonay()">
                      <i class="la la-edit" title="Düzenle"  
                      style="font-size:30;cursor: pointer;font-weight: bold;color:white;"></i>
                      Etiketi düzenle</button>
          <div class="etiket">
            <div class="ust">
                <span>Hasta Ad Soyad</span>
                <span>01.01.2025</span>
            </div>
            <div class="icerik">
                <p><b>{{label?.drugLabelInformation?.drugName}}</b> <span style="float:right;"><b>Bitiş Tarihi:</b> 01.01.2025</span></p>
                <p>{{label?.drugLabelInformation?.usagePurpose}}</p>
        
                <p><b>KULLANIM:</b><br>
               {{label?.drugLabelInformation?.usageInstructions}}
                </p>
        
                <div class="uyarilar">
                    <b>UYARILAR:</b>
                    <ul>
                        <li *ngFor="let u of label?.drugLabelInformation?.warnings">{{u}}</li>
                       
                    </ul>
                </div>
            </div>
            <div class="alt">
                <span>XXXXXX ECZANESİ (555) 555 55 55</span>
                
            </div>
        </div>
        </div>
      </div>

      

    <div class="row">
      <div class="col-md-12">
         
        <div class="iphone-frame">
          <div class="notch"></div>
      
          <h1>{{label?.patientMobileAppDrugInformation?.drugName}}</h1>
      
          <div class="image-box">
              <img src="assets/images/ilac.png" alt="">
          </div>
      
          <div class="section">
              <span class="icon">💉</span>
              <b>İlaç Adı:</b>{{label?.patientMobileAppDrugInformation?.drugName}}
          </div>
      
          <div class="section">
              <span class="icon">⚗️</span>
              <b>Etken Madde:</b> <ul>
                <li *ngFor="let u of label?.patientMobileAppDrugInformation?.activeIngredients">{{u.name}} {{u.amunt}}</li>
               
            </ul>
          </div>
      
          <div class="section">
              <span class="icon">❄️</span>
              <b>Endikasyon:</b> {{label?.patientMobileAppDrugInformation?.indications}}
          </div>
      
          <div class="section">
              <span class="icon">⏱️</span>
              <b>Doz Talimatı:</b> 
              {{label?.patientMobileAppDrugInformation?.dosageInstructions?.adults}}<br/>
             <span *ngIf="label?.patientMobileAppDrugInformation?.dosageInstructions?.maximumDailyDose">Günlük maksimum: {{label?.patientMobileAppDrugInformation?.dosageInstructions?.maximumDailyDose}}</span> 
          </div>
      
          <div class="section">
              <span class="icon">❗</span>
              <b>Uyarılar:</b>
              <ul>
                  <li *ngFor="let u of label?.patientMobileAppDrugInformation?.warnings">{{u}}</li>
                 
              </ul>
          </div>
      
          <div class="section">
              <span class="icon">🚫</span>
              <span class="warning">Yutulmaz.</span> 
              
              {{label?.patientMobileAppDrugInformation?.administrationMethodNote}}
          </div>
      </div>
      </div>
                  </div>
                </div>
              </div>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
